export default "__VITE_ASSET__C8a_EIcV__"